import { GET_ASSIGNVEHICLE_REQUESTED, GET_LISTASSIGNEDVEHICLE_REQUESTED, GET_REQUESTVEHICLE_REQUESTED, GET_UPDATEASSIGNDRIVER_REQUESTED, GET_UPDATEASSIGNVEHICLE_REQUESTED,GET_ASSIGN_DRIVER_REQUESTED, GET_UPDATEASSIGNSUBVENDOR_REQUESTED } from "resources/actionTypes";

export function getRequestVehicle(data) {
  return {
    type: GET_REQUESTVEHICLE_REQUESTED,
    payload: data,
  };
}
export function getListAssignedVehicle(data) {
  return {
    type: GET_LISTASSIGNEDVEHICLE_REQUESTED,
    payload: data,
  };
}
export function getAssignVehicle(data) {
  return {
    type: GET_ASSIGNVEHICLE_REQUESTED,
    payload: data,
  };
}
export function updateAssignVehicle(val,toggle) {
  const data ={
    userUpdateAssignVehicle: val,
    setConfirmModal: toggle,
  }

  return {
    type: GET_UPDATEASSIGNVEHICLE_REQUESTED,
    payload: data,
  };
}
export function updateAssignDriver(val,toggle) {
  const data ={
    userUpdateAssignDriver: val,
    setConfirmModal: toggle,
  }
  return {
    type: GET_UPDATEASSIGNDRIVER_REQUESTED,
    payload: data,
  }
}

export function getAssignDriver(data) {
  return {
    type: GET_ASSIGN_DRIVER_REQUESTED,
    payload:data
  };
}

export function updateAssignSubVendor(val,toggle) {
  const data ={
    userUpdateAssignSubVendor: val,
    setConfirmModal: toggle,
  }
  return {
    type: GET_UPDATEASSIGNSUBVENDOR_REQUESTED,
    payload: data,
  }
}